import e from "../style.module.css";
import { useLocation } from "wouter";
import { assets, url, urlInv } from "Utils/DBHelper/Helper";
import { useMenu } from "context/MenuContext";

export const ServicesLinks = () => {
  const [, setLocation] = useLocation();
  const { array_menus } = useMenu();
  const storedUserType = JSON.parse(localStorage.getItem('user') || '{}');
  return (
    <div className={`${e["dina__elem-wrapper"]}`}>
      <h3>¿Qué deseas hacer?</h3>
      { array_menus?.length ? (
        <div className={`${e.dina__container}`}>
          {array_menus.map((ele: any) => (
            <div
              className={e.dina__elem}
              key={"opt_" + ele._id}
              onClick={() => setLocation(ele.url || storedUserType?.user?._tipoUsuario === 'Individual' ? urlInv[ele._id] : url[ele._id])}
            >
              <img
                src={ele._imagen || assets[ele._id]}
                alt={`Icono boton ir a mis ${ele._nomenclatura}`}
                className={e["dina__elem-icon"]}
              />
              <p className={`${e["dina__elem-text"]}`}>{ele._nombre}</p>
              <h4 className={`${e["dina__elem-text"]}`}>{ele._nomenclatura}</h4>
            </div>
          ))}
        </div>
      ) : (
        <div className={e["nof-user-container"]}>
          <h5>
            <i className="bi bi-exclamation-triangle"></i> No se encontraron
            opciones para mostrar.
          </h5>
          <p>Por favor contacte a soporte.</p>
        </div>
      )}
    </div>
  );
};
